import { ForwardedRef, forwardRef } from "react";
import { SelectInstance } from "react-select";
import { LoadingGroup } from "capitalrx-components-2.0/lib/general";
import { useId } from "../../hooks/useId";
import { getBasePropsFromHtmlProps, getHtmlPropsFromBaseProps } from "../../utilities";
import { Dropdown } from "../Dropdown";
import { OptionItem } from "../Dropdown/OptionItem";
import { useInputDisabled, useInputReadonly } from "../InputGroup";
import { InputContainer } from "../shared";
import { DataDropdownProps } from "./DataDropdown";
import { SharedDataDropdown } from "./SharedDataDropdown";
export interface InputProps extends DataDropdownProps<object> {
  /**
   * Indicates whether the input is required.
   */
  readonly required?: boolean;
}

export const Input = forwardRef(function Input(props: InputProps, ref: ForwardedRef<SelectInstance<OptionItem | null, boolean>>) {
  const { label, instructions, tooltip, required = false, hideInstructions, hideLabel, autoComplete = "off" } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: ["data-dropdown"],
    testIdPrefix: "data-dropdown",
  });

  const id = useId();
  const disabled = useInputDisabled(props);
  const readOnly = useInputReadonly(props);

  return (
    <LoadingGroup.Placeholder fallback={<Dropdown.Placeholder className={props.className} style={props.style} />}>
      <InputContainer
        {...getBasePropsFromHtmlProps(baseHtmlProps)}
        id={id}
        label={label}
        instructions={instructions}
        disabled={disabled}
        readOnly={readOnly}
        tooltip={tooltip}
        required={required}
        hideInstructions={hideInstructions}
        hideLabel={hideLabel}
      >
        <SharedDataDropdown
          id={id}
          ref={ref}
          {...props}
          autoComplete={autoComplete}
        />
      </InputContainer>
    </LoadingGroup.Placeholder>
  );
});
